module.exports = __webpack_public_path__ + "img/lpfv-pc-5000.55ae5d95.png";